
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-time-offer",
      function () {
        return require("private-next-pages/first-time-offer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-time-offer"])
      });
    }
  